module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0080.png.d4551d76.jpg";